import React from "react";

import { Alert, Button, Stack, Typography } from "@mui/material";

import { PsychologyReverse } from "../../../assets/material-custom-icons";
import { ITagger } from "../../../store/types";
import { ThreeDots } from "../ThreeDots/ThreeDots";

interface SmartTagBarProps {
  status: ITagger["analyzingStatus"];
  onAnalyze: () => void;
  onStop: () => void;
  onUndo: () => void;
}

export const SmartTagBar: React.FC<SmartTagBarProps> = (props) => {
  if (props.status === "processing") {
    return (
      <Alert
        variant="filled"
        icon={false}
        sx={{
          bgcolor: "rgba(38, 166, 174, 1)",
          mb: "20px",
          ".MuiAlert-action": {
            padding: "4px 4px 4px 16px"
          }
        }}
        action={
          <Button onClick={props.onStop} sx={{ bgcolor: "white", ":hover": { bgcolor: "rgba(232, 232, 232, 1)" } }}>
            Stop auto-tagging
          </Button>
        }
      >
        <Stack>
          <Stack flexDirection="row" gap="10px" alignItems="center" justifyContent="center">
            <ThreeDots />
            <Typography noWrap fontWeight="500" fontSize="14px">
              The file is auto-tagging
            </Typography>
            <Typography noWrap fontWeight="300" fontSize="14px">
              This process will take some time so you can wait or return to the file later
            </Typography>
          </Stack>
        </Stack>
      </Alert>
    );
  } else if (props.status === "pending") {
    return (
      <Stack flexDirection="row" gap="10px" alignItems="center" justifyContent="flex-start" mb="20px">
        <Button variant="contained" onClick={props.onAnalyze}>
          <Stack flexDirection="row" alignItems="center" justifyContent="center" gap="5px">
            <PsychologyReverse sx={{ fill: "white" }} />
            <Typography>Smart Tag</Typography>
          </Stack>
        </Button>
        <Typography variant="body3" color="rgba(7, 31, 53, 1)">
          Smart tag available. Use this function to autocomplete the data.
        </Typography>
      </Stack>
    );
  } else if (props.status === "finished") {
    return (
      <Stack flexDirection="row" gap="10px" alignItems="center" justifyContent="flex-start" mb="20px">
        <Typography>The file has been auto-tagged</Typography>
        <Button variant="text" sx={{ color: "#26A6AE", padding: 0 }} onClick={props.onUndo}>
          Undo
        </Button>
      </Stack>
    );
  }
  return null;
};
